import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { selectParams } from 'src/modules/reducers/params'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // Detect for fox referral and show banner if redirect from fox domain
  const [foxRedirect, setFoxRedirect] = useState(false)
  const params = useSelector(selectParams)

  useEffect(() => {
    const docReferrer = document && document.referrer
    if ((docReferrer && docReferrer.includes('fox')) || params?.fox_redirect === 'true') {
      setFoxRedirect(true)
    }
  }, [params])

  const offerBanner = {
    title: [
      "You've been redirected to Fubo.",
      "Follow the biggest stories on America's most watched news network.",
    ],
  }

  const videoStructuredData = createVideoStructuredData({
    networkName: 'FOX News',
    callsign: 'FNCHD',
    logoUrl: networkLogos.foxnews.logoUrl,
    slug: 'fox-news',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        offerBanner={foxRedirect ? offerBanner : null}
        callsign="FNCHD"
        title="Watch FOX News live with Fubo"
        foxRedirect={foxRedirect}
        networkName="FOX News"
      />
    </>
  )
}
